import { render, staticRenderFns } from "./exercise.vue?vue&type=template&id=2ee0cccd&scoped=true&"
import script from "./exercise.vue?vue&type=script&lang=ts&"
export * from "./exercise.vue?vue&type=script&lang=ts&"
import style0 from "./exercise.vue?vue&type=style&index=0&id=2ee0cccd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee0cccd",
  null
  
)

export default component.exports